import React from 'react'
import {Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Link from "next/link";
import {createStyles, makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => createStyles({
    container: {
        position: 'relative',
        minHeight: 250,
        marginBottom: theme.spacing(4),
    },
    imageContainer: {
        [theme.breakpoints.only('xs')]: {
            position: 'relative',
            textAlign: 'center',
        },
        position: 'absolute',
    },
    textContainer: {
        [theme.breakpoints.only('xs')]: {
            marginLeft: 0
        },
        [theme.breakpoints.only('sm')]: {
            marginLeft: 200
        },
        marginLeft: 270
    },
    image: {
        [theme.breakpoints.only('xs')]: {
            maxWidth: 170
        },
        [theme.breakpoints.only('sm')]: {
            maxWidth: 190
        },
        maxWidth: 260,
        maxHeight: '100%',
    },
    link: {
        color: theme.palette.text.primary,
    },
}));

interface TeaserProps {
    image: {
        src: string
        srcSet: string
    }
    headline: string
    description: string
    href?: string
    asHref?: string
    ctaUrl?: string
    ctaLabel?: string
}

function Teaser(props: TeaserProps) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.imageContainer}>
                <img className={classes.image} src={props.image.src} srcSet={props.image.srcSet} alt={""}/>
            </div>
            <div className={classes.textContainer}>
                { props.href && (
                    <Link href={props.href} as={props.asHref}>
                        <a className={classes.link}>
                            <Typography variant={"h2"} gutterBottom>{props.headline}</Typography>
                        </a>
                    </Link>
                )}
                { !props.href && (
                    <Typography variant={"h2"} gutterBottom>{props.headline}</Typography>
                )}
                <Typography component={"p"} color={"textSecondary"}>{props.description}</Typography>
                { props.ctaLabel && (
                    <Button variant={"contained"} href={props.ctaUrl}>
                        {props.ctaLabel}
                    </Button>
                )}
            </div>
        </div>
    );
}

export default Teaser;
